import { Component } from '@angular/core';
import { ModalRef } from 'asksuite-citrus';

@Component({
  selector: 'app-phone-status-confirmation-modal',
  templateUrl: './phone-status-confirmation-modal.component.html',
  styleUrls: ['./phone-status-confirmation-modal.component.scss'],
})
export class PhoneStatusConfirmationModalComponent {
  constructor(private modalRef: ModalRef) {}

  onCancelClick(): void {
    this.modalRef.close({ confirmed: false });
  }

  onConfirmClick(): void {
    this.modalRef.close({ confirmed: true });
  }
}
